import { render, staticRenderFns } from "./squidtoon.vue?vue&type=template&id=41311d72&scoped=true"
import script from "./squidtoon.vue?vue&type=script&lang=js"
export * from "./squidtoon.vue?vue&type=script&lang=js"
import style0 from "./squidtoon.vue?vue&type=style&index=0&id=41311d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41311d72",
  null
  
)

export default component.exports